import type { ReactNode } from "react";

export function Field({
  label,
  error,
  children,
  icon,
}: {
  label: string;
  error?: string;
  children: ReactNode;
  icon?: ReactNode;
}) {
  return (
    <label className="group block space-y-1.5">
      <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-[var(--color-charcoalGray)] transition-colors group-focus-within:text-[var(--color-tealGreen)] dark:text-[var(--color-muted)] dark:group-focus-within:text-[var(--color-primary)]">
        {icon}
        {label}
      </span>
      {children}
      {error && (
        <p className="flex items-center gap-1 text-xs font-medium text-[var(--color-error)]">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" className="shrink-0">
            <circle cx="6" cy="6" r="5.5" stroke="currentColor" strokeWidth="1" />
            <path d="M6 3.5v2.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
            <circle cx="6" cy="8.5" r="0.5" fill="currentColor" />
          </svg>
          {error}
        </p>
      )}
    </label>
  );
}
